import React from "react";
import parse from "html-react-parser";
import "./Practise_List_Component.css";
import { IDS } from "../../../utils/IDS";

const Practise_List_Component = ({ event, eventPrograms }) => {
  const data = [
    {
      title: "From Ashrams to Hearts Across the World",
      img: "/assets/images/simple_steps/img1.png",
      footer_text: "Now, it’s your turn.",
      descn:
        "Millions of people across the globe have experienced profound transformation through the timeless wisdom and practices shared by our ashram. Whether seeking inner peace, clarity, or spiritual growth — their journey began with a single step inward. ",
    },
    {
      title: "From Ashrams to Hearts Across the World",
      img: "/assets/images/simple_steps/img1.png",
      footer_text: "Now, it’s your turn.",
      descn:
        "Millions of people across the globe have experienced profound transformation through the timeless wisdom and practices shared by our ashram. Whether seeking inner peace, clarity, or spiritual growth — their journey began with a single step inward. ",
    },
    {
      title: "From Ashrams to Hearts Across the World",
      img: "/assets/images/simple_steps/img1.png",
      footer_text: "Now, it’s your turn.",
      descn:
        "Millions of people across the globe have experienced profound transformation through the timeless wisdom and practices shared by our ashram. Whether seeking inner peace, clarity, or spiritual growth — their journey began with a single step inward. ",
    },
  ];

  return (
    <section className="Practise_List_Component">
      <div className="container">
        <div className="main_content_holder">
          <div className="row">
            {eventPrograms?.map((item) => {
              return (
                <div className="col-lg-4 col-sm-6 mb-4">
                  <div className="practise_card">
                    <div className="title_div">
                      <p className="title_text">{item?.name || " "}</p>
                    </div>
                    <div className="img_holder">
                      <img src={IDS.IMG_URL + item?.Event_program
                        ?.image} className="card_img" />
                    </div>

                    <div className="text_holder">
                      <p className="inner_text">{item?.description || " "}</p>
                      {/* <p className="footer_text">{item?.footer_text || "Now, it’s your turn."}</p> */}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className='tablediv mt-5'>
            <h5 className='morningh5'>Guidelines</h5>
            <div className='guidelinesdiv'>
              {parse(event?.guidelines || " ")}

            </div>
          </div>
          <div className="outer_div">
            <div className="gray_div">
              <span className="inner_text">{event?.conclusion || " "}              </span>
            </div>
          </div>




        </div>
      </div>
    </section>
  );
};

export default Practise_List_Component;
